const STATUS_STYLES = {
  received: 'bg-blue-100 text-blue-800',
  verifying: 'bg-yellow-100 text-yellow-800',
  filling: 'bg-purple-100 text-purple-800',
  ready: 'bg-green-100 text-green-800',
  dispensed: 'bg-emerald-100 text-emerald-800',
  'Active': 'bg-green-100 text-green-800',
  'Expiring Soon': 'bg-orange-100 text-orange-800',
  'Expired': 'bg-red-100 text-red-800',
  'Received': 'bg-blue-100 text-blue-800',
  'Verifying': 'bg-yellow-100 text-yellow-800',
  'Filling': 'bg-purple-100 text-purple-800',
  'Processing': 'bg-purple-100 text-purple-800',
  'Preparing': 'bg-yellow-100 text-yellow-800',
  'Ready for Pickup': 'bg-cyan-100 text-cyan-800',
  'Collected': 'bg-green-100 text-green-800',
  'Packing': 'bg-indigo-100 text-indigo-800',
  'Ready for Dispatch': 'bg-cyan-100 text-cyan-800',
  'Dispatched': 'bg-blue-100 text-blue-800',
  'Delivered': 'bg-emerald-100 text-emerald-800',
};

const StatusBadge = ({ status, className = '' }) => {
  const style = STATUS_STYLES[status] || 'bg-gray-100 text-gray-800';
  const label = status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <span className={`inline-block text-xs px-2.5 py-1 rounded-full font-medium ${style} ${className}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
